// Copyright (c) 2017 Deere & Company

import React, {PropTypes} from 'react';
import EditableField from '../../../shared/components/editable-field';
import {FormattedMessage} from 'react-intl';
import FormattedNumberInput from '../../../shared/components/formatted-number-input';
import Rate from '@deere/cps-it.warranty-model-factory/lib/rate';
import {buildCurrency} from '../../../shared/services/build-number';

function handleRequestedRateChange(index, rate) {

    const updatedRate = rate ?
        parseFloat(rate) :
        null;

    this.actions.updateRequestedRate(index, updatedRate);

}

function handleCommentsChange(index, event) {

    this.actions.updateComments(index, event.target.value);

    if (this.rates[index].reasonForChange !== event.target.value) {

        this.actions.updateIsSubmitDisabled(false);

    }

}

const LaborRates = props =>
    <section className='labor-rates'>
        <ul className='column-headers'>
            <li>
                <FormattedMessage id='LABOR_TYPE'/>
            </li>
            <li>
                <FormattedMessage id='CURRENT'/>
            </li>
            <li>
                <FormattedMessage id='REQUESTED'/>
            </li>
            <li>
                <FormattedMessage id='COMMENTS'/>
            </li>
        </ul>
        {props.rates.map((rate, index) =>
            <ul
                className='data'
                key={index}
            >
                <li>
                    {rate.description}
                </li>
                <li>
                    {buildCurrency(rate.currentRate)}
                </li>
                <li>
                    <EditableField
                        isEditable={!props.tcsm}
                        value={buildCurrency(rate.requestedRate)}
                    >
                        <FormattedNumberInput
                            allowNegative={false}
                            decimalPrecision={2}
                            isValidInput={value => value < 10000000}
                            onValueChange={handleRequestedRateChange.bind(props, index)}
                            value={rate.requestedRate}
                        />
                    </EditableField>
                </li>
                <li>
                    <EditableField
                        isEditable={!props.tcsm}
                        value={rate.reasonForChange}
                    >
                        <textarea
                            className='reason-for-change'
                            maxLength='255'
                            onChange={handleCommentsChange.bind(props, index)}
                            value={rate.reasonForChange}
                        />
                    </EditableField>
                </li>
            </ul>
        )}
    </section>;

LaborRates.displayName = 'LaborRates';
LaborRates.propTypes = {
    actions: PropTypes.object.isRequired,
    rates: PropTypes.arrayOf(PropTypes.instanceOf(Rate)).isRequired,
    tcsm: PropTypes.bool.isRequired
};

export default LaborRates;



// WEBPACK FOOTER //
// ./src/claim/labor-rate-change/components/labor-rates.js